import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../../../shared/theme';
import Type from '../../../shared/fund/type';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 6px;
  border: 1px solid #E9EEF3;
  box-sizing: border-box;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.12);

  ${props => !props.theme.isFeaturedLarge && `
    flex-direction: column;
  `};

  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px 32px 26px;

  ${props => props.theme.isMobile && `
    padding-left: 16px;
    padding-right: 16px;
  `};

  > div {
    margin-bottom: 2px;

    > span {
      font-weight: 800;
      font-size: 12px;
      padding: 2px 8px;

      ${props => dt(props).theme.isXXLarge && `
        font-size: 13px;
      `};
    }
  }
`;

const Footer = styled.div`
  padding: 24px 24px 0;
  display: flex;
  flex-direction: column;
  text-align: center;

  ${props => !props.theme.isFeaturedLarge && `
    margin-top: 0;
    padding-top: 0px;
    padding-bottom: 32px;
    width: 100%;
  `};

  ${props => props.theme.isMobile && `
    padding-left: 16px;
    padding-right: 16px;
  `};
`;

const Name = styled.div`
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: 700;
  font-size: 25px;
  line-height: 110%;
  margin-top: 6px;

  a {
    color: ${props => props.theme.bodyColor};

    &:hover {
      text-decoration: none;
    }
  }
`;

const CompanyName = styled.div`
  color: ${props => props.theme.secondaryColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 19px;
  line-height: 120%;
  margin-top: 8px;
`;

const ButtonLink = styled.a`
  background: #3D4A63;
  border: 1px solid #3D4A63;
  border-radius: 2px;
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 14px;
  line-height: 120%;
  text-transform: uppercase;
  padding: 12px;
  width: 146px;

  &:hover {
    text-decoration: none !important;
    color: ${props => props.theme.bodyBackgroundColor};
    cursor: pointer;
  }

  ${props => props.theme.isMobile && `
    display: inline-block;
    text-align: center;
    width: 100%;
  `};
`;

export default function Card({ company, fund }) {
  const { type, name, publicUrl } = fund;

  return (
    <Container>
      <Content>
        {!!type && <Type type={type} />}
        <Name><a href={publicUrl}>{name}</a></Name>
        <CompanyName>{company.name}</CompanyName>
      </Content>
      <Footer>
        <ButtonLink href={publicUrl}>Learn More</ButtonLink>
      </Footer>
    </Container>
  );
}

Card.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  fund: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    publicUrl: PropTypes.string.isRequired,
  }).isRequired,
};
